export const setLabel = (label, lang) => {
  switch (label) {
    case 'Dashboard':
      label = (lang === 'fr') ? 'Tableau de bord' : 'Dashboard';
      return label;
    case 'My Policies':
      label = (lang === 'fr') ? 'Mes polices' : 'My Policies';
      return label;
    case 'Claims':
      label = (lang === 'fr') ? 'Réclamations' : 'Claims';
      return label;
    case 'Offers':
      label = (lang === 'fr') ? 'Offres' : 'Offers';
      return label;
    case 'Settings':
      label = (lang === 'fr') ? 'Paramètres' : 'Settings';
      return label;
    default:
      console.log('no labels found');
      break;
  }
};
